import {
  AnalyticsQueryParams,
  ContentDetailQueryParams,
} from '@raydiant/api-client-js';
import {
  AnalyticsFilterQuery,
  AnalyticsFilterQueryKeys,
} from './AnalyticsFilter';
import { DEFAULT_DATE_RANGE, DEFAULT_DATE_RANGE_KEY } from './DateRangeSelect';
import moment from 'moment';

export const getDefaultQueryParams = () => {
  let data: AnalyticsFilterQuery = {};

  data.location_id = '';
  data.from = DEFAULT_DATE_RANGE.from;
  data.to = DEFAULT_DATE_RANGE.to;
  data.dateRangeKey = DEFAULT_DATE_RANGE_KEY;
  data.presentation_id = '';
  data.device_id = '';

  return data;
};

export const getUrlQueryParams = (query: string) => {
  let data: AnalyticsFilterQuery = {};

  const keys: AnalyticsFilterQueryKeys[] = [
    'location_id',
    'from',
    'to',
    'dateRangeKey',
    'presentation_id',
    'device_id',
  ];

  keys.forEach((key) => {
    const value = getQueryParam(query, key);

    if (value) data[key] = value as any;
  });

  return data;
};

export const getApiQueryParams = (query: string) => {
  let { dateRangeKey, ...data } = getUrlQueryParams(query);
  const defaultParams = getDefaultQueryParams();

  return (
    Object.keys(data).length > 0 ? data : defaultParams
  ) as AnalyticsQueryParams;
};

export const getQueryParam = (query: string, key: string) => {
  const url = new URLSearchParams(query);

  return url.get(key);
};

export const parseDateToString = (
  date: moment.MomentInput,
  format = 'YYYY-MM-DD',
) => moment(date).format(format).toString();

export const getContentDetailApiQueryParams = (query: string) => {
  let { ...data } = getUrlQueryParams(query);
  const defaultParams = getDefaultQueryParams();
  // as we have the presentation_id in the query params, we need to change default params for content detail page
  // for saving the presentation_id there
  const defaultParamsForContentDetail = {
    ...defaultParams,
    presentation_id: data.presentation_id,
  };

  return (
    data.dateRangeKey ? data : defaultParamsForContentDetail
  ) as ContentDetailQueryParams & { dateRangeKey: string };
};

export const getContentDetailApiQueryParamsDefault = (
  presentationId: string,
) => {
  let data: AnalyticsFilterQuery = {};

  data.location_id = '';
  data.from = DEFAULT_DATE_RANGE.from;
  data.to = DEFAULT_DATE_RANGE.to;
  data.dateRangeKey = DEFAULT_DATE_RANGE_KEY;
  data.presentation_id = presentationId;
  data.device_id = '';

  return data;
};
